import b from "./index250.js";
import { resolveComponent as d, createElementBlock as l, openBlock as s, normalizeClass as i, createElementVNode as n, createCommentVNode as r, Fragment as f, renderList as w, toDisplayString as a, createBlock as p, createVNode as k } from "vue";
/* empty css         */
import v from "./index231.js";
const g = ["data-component"], y = { class: "cs-dropdown__wrapper" }, _ = ["disabled"], D = {
  key: 0,
  value: ""
}, B = ["value", "selected"], C = { class: "pointer-events-none cs-dropdown__label" }, E = { class: "cs-dropdown__value text-text-l" }, F = { class: "flex items-center justify-center h-full ml-auto px-14" }, $ = {
  key: 0,
  class: "mt-12 text-caption text-color-alert-negative-100",
  "data-test-id": "error"
};
function V(e, t, N, z, L, j) {
  const u = d("ms-disabled"), m = d("ms-warning-circle"), c = d("ms-arrow-down");
  return s(), l("div", {
    "data-component": e.$options.name,
    class: i(["cs-dropdown", {
      "-focus": e.hasFocus,
      "-filled": e.isFilled,
      "-error": e.hasError && !e.isDisabled,
      "-disabled": e.isDisabled
    }])
  }, [
    n("label", y, [
      n("select", {
        ref: "selectRef",
        class: i(["absolute w-full h-full opacity-0 z-content disabled:opacity-0", {
          "cursor-not-allowed": e.isDisabled,
          "cursor-pointer": !e.isDisabled
        }]),
        autocomplete: "off",
        disabled: e.isDisabled,
        onFocus: t[0] || (t[0] = (...o) => e.onFocus && e.onFocus(...o)),
        onBlur: t[1] || (t[1] = (...o) => e.onBlur && e.onBlur(...o)),
        onChange: t[2] || (t[2] = (...o) => e.onChange && e.onChange(...o))
      }, [
        e.noEmptyOption ? r("", !0) : (s(), l("option", D, " Beliebig ")),
        e.options && e.options.length ? (s(!0), l(f, { key: 1 }, w(e.options, (o, h) => (s(), l("option", {
          key: o.value + h,
          value: o.value,
          selected: o.value === e.modelValue
        }, a(o.label), 9, B))), 128)) : r("", !0)
      ], 42, _),
      n("span", C, a(e.label), 1),
      n("span", E, a(e.currentLabel), 1),
      n("span", F, [
        e.isDisabled ? (s(), p(u, {
          key: 0,
          class: "mr-8 h-lh-text-l-desktop w-lh-text-l-desktop"
        })) : r("", !0),
        e.hasError && !e.isDisabled ? (s(), p(m, {
          key: 1,
          class: "mr-8 h-lh-text-l-desktop w-lh-text-l-desktop"
        })) : r("", !0),
        k(c, { class: "h-lh-text-l-desktop w-lh-text-l-desktop" })
      ])
    ]),
    e.hasError && !e.isDisabled ? (s(), l("div", $, a(e.errorMsg), 1)) : r("", !0)
  ], 10, g);
}
const S = /* @__PURE__ */ v(b, [["render", V], ["__scopeId", "data-v-485b4986"]]);
export {
  S as default
};
